import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DocumentCategoryApi } from 'api';

import { RootState } from '../app';

export const findDocumentCategory = createAsyncThunk(
  'documentCategory/findDocumentCategory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await DocumentCategoryApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  isInitData: boolean;
  entityDocumentSubCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả chứng từ',
    },
  ],
  isInitData: false,
  entityDocumentSubCategoriesHash: {},
};

const documentCategorySlice = createSlice({
  name: 'documentCategory',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findDocumentCategory.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: documentCategoryReducer } = documentCategorySlice;

export default documentCategoryReducer;

export const selectDocumentCategory = (state: RootState): IState =>
  state.documentCategory as IState;
